import { REPORT_SOURCE, SUBMISSION_MODE } from 'src/types';

export const mapSubmissionModeToReportSource = (
  submissionMode?: number | null,
): REPORT_SOURCE => {
  switch (submissionMode) {
    case SUBMISSION_MODE.APP_GO_TOGETHER:
    case SUBMISSION_MODE.APP_GO_AHEAD:
    case SUBMISSION_MODE.APP_GO_ANONYMOUS:
      return REPORT_SOURCE['app'];
    case SUBMISSION_MODE.OPEN_REPORTING:
      return REPORT_SOURCE['open-reporting'];
    case SUBMISSION_MODE.MCC:
      return REPORT_SOURCE['manual-case-creation'];
    case SUBMISSION_MODE.VAULT_TALK:
      return REPORT_SOURCE['vault-talk'];
    case SUBMISSION_MODE.BULK_IMPORT:
      return REPORT_SOURCE['imported'];
    case SUBMISSION_MODE.REPORTER_PORTAL:
    case SUBMISSION_MODE.REPORTER_PORTAL_GO_TOGETHER:
      return REPORT_SOURCE['reporter-portal'];
    default:
      return REPORT_SOURCE['unknown'];
  }
};
